import React from "react";
import licenciaLogo from "src/assets/images/licencia-1.jpg";

export default function LicenceImage()
{
    return <img src={licenciaLogo} alt="Imagen de licencia"/>
}
